import React from 'react'
import Footer from '../components/Footer'

const Eligibility = () => {
  return (
    <div className=' w-full relative ' >
        <h2 className={` mb-4 text-2xl md:text-5xl tracking-tight mt-[100px] md:mt-[160px] font-bold text-center text-[#0e4d38]`}>Eligibility Criteria</h2>
        <div className=' w-10/12 mx-auto flex flex-col justify-between gap-[40px]' >
        <div className="flex flex-col mt-10 mb-[100px] ">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                    <div className="overflow-hidden">
                        <table className="min-w-full text-center text-sm font-light">
                        <thead
                            className="border-b bg-[#23376c] font-medium text-white rounded-md ">
                            <tr>
                            <th scope="col" className=" px-6 py-4">Course</th>
                            <th scope="col" className=" px-6 py-4">Branch</th>
                            <th scope="col" className=" px-6 py-4">Eligibility Criteria</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " rowSpan={8} >B.Tech</td>
                            <td className="whitespace-nowrap  px-6 py-4">Computer Science</td>
                            <td className="whitespace-nowrap  px-6 py-4" rowSpan={6} >Intermediate / 10+2 or its equivalent examination with PCM (Physics, Chemistry, Maths) from a recognized <br/> Board/ University/ MDU Entrance Examination</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >Cloud Computing</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >Data Science</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >Cyber Security</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >AI/ML</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >Civil</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >Mechanical Engg.</td>
                            <td className="whitespace-nowrap  px-6 py-4" rowSpan={2} >Merit prepared on basis of 10+2 PCM/B.Sc(PCM)/Diploma in Mechanical/Electrical,<br/> Electronics Engg/MDU Entrance examination</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >Mechatronics & Robotics</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " rowSpan={10} >M.Tech</td>
                            <td className="whitespace-nowrap  px-6 py-4">Data Science</td>
                            <td className="whitespace-nowrap  px-6 py-4" rowSpan={6} >Bachelor degree in Engineering/Technology or equivalent or a Master degree in Science/MDU Entrance examination</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >AI/ML</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >Digital Communication</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >Structural Engineering</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >Transportation Engineering</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >Environmental Engineering</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >EV Technology</td>
                            <td className="whitespace-nowrap  px-6 py-4 " >Merit prepared on basis of B.Tech.(Mechanical/Electrical/Electronic Engg)/MCA/M.Sc/MDU Entrance examination</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >Production Engineering</td>
                            <td className="whitespace-nowrap  px-6 py-4 " >Merit prepared on basis of B.Tech.(Mechanical/Production/Industrial Engg./ Manufacturing)/MCA/MSc/MDU Entrance examination</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >Thermal Engineering</td>
                            <td className="whitespace-nowrap  px-6 py-4 " >Merit prepared on basis of B.Tech.(Mechanical/Automobile/Industrial/Manufacturing Engg.)/MCA/M.Sc/MDU Entrance examination</td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                    </div>
                </div>
                </div>
        </div>
        <Footer/>
    </div>
  )
}

export default Eligibility